import { useQuery } from '@tanstack/react-query';
import type { RoundPhase } from '@uefadigital/panenka';

import { getAllTeamsQuery } from '../queries/teams';

import { hydrateWithTranslations } from '@services/TranslatorService';
import { orderBy } from '@utilities/collection-utils';

export const useTeams = ({
  competitionId,
  seasonYear,
  phase,
  isDomestic,
  disable = false,
}: {
  competitionId: string;
  seasonYear: string;
  phase?: RoundPhase | 'ALL';
  isDomestic?: boolean;
  disable?: boolean;
}) => {
  const { data: teams } = useQuery({
    ...getAllTeamsQuery({ competitionId, seasonYear, phase, isDomestic }),
    select: (result) =>
      orderBy(
        result.map((team) => hydrateWithTranslations(team)),
        'displayName',
      ),
    enabled: !disable,
  });

  return teams;
};
